import { useTranslation } from "@next-platform/client-common-core";
import { SubCapabilityKey, useApplicationCapabilitiesAllowed } from "@next-platform/client-common-core/infra/application/capabilities";
import { CharacterCardActions, IconVariants } from "@next-platform/client-common-spicy-ui";
import React from "react";

import CharacterCard from "@/components/Character/CharacterCard/variants";

import { CharacterCardData, CharacterCardDropdownActions } from "../../types";

interface ISharedChatbotCardProps {
  characterData: CharacterCardData;
  onAction: (action: CharacterCardActions | CharacterCardDropdownActions, characterId: string) => void;
  isAuthenticated: boolean;
  centeredElementIds: string[];
  setElementRef: (id: string, el: HTMLElement | null) => void;
}

const SharedChatbotCard = ({ characterData, onAction, isAuthenticated, centeredElementIds, setElementRef }: ISharedChatbotCardProps) => {
  const { t } = useTranslation();
  const isCharacterShareLinkAllowed = useApplicationCapabilitiesAllowed(SubCapabilityKey.CharacterShareLink);
  const dropdownActions = [
    ...(isCharacterShareLinkAllowed
      ? [
          {
            label: t("chatbotCard:dropdown.share"),
            icon: IconVariants.SHARE,
            onPress: () => onAction(CharacterCardDropdownActions.SHARE, characterData?.characterId),
          },
        ]
      : []),
    {
      label: t("chatbotCard:dropdown.report"),
      icon: IconVariants.FLAG,
      onPress: () => onAction(CharacterCardDropdownActions.REPORT, characterData?.characterId),
    },
    {
      label: t("chatbotCard:dropdown.blockCreator"),
      icon: IconVariants.USER_CANCEL,
      onPress: () => onAction(CharacterCardDropdownActions.BLOCK, characterData?.characterId),
      isHidden: !isAuthenticated,
    },
    {
      label: t("chatbotCard:dropdown.lessLikeThis"),
      icon: IconVariants.CIRCLE_MINUS,
      onPress: () => onAction(CharacterCardDropdownActions.LESS_LIKE_THIS, characterData?.characterId),
      isHidden: !isAuthenticated,
    },
  ];

  return (
    <div ref={(el) => setElementRef(characterData?.characterId, el)}>
      <CharacterCard
        characterInfo={characterData}
        characterCardActionsHandler={onAction}
        characterCardActionsState={characterData?.characterActionsState}
        atCenter={centeredElementIds.includes(characterData?.characterId)}
        variant={characterData?.characterCardVariant}
        dropdownMenuActions={dropdownActions}
      />
    </div>
  );
};

export default SharedChatbotCard;
